export const DASHBOARD_ROUTE = '/dashboard'
export const BOOKING_ROUTE = '/bookings'
export const GOCHECKIN_ROUTE = '/go-checkin'
export const COUPON_ROUTE = '/coupons'
export const CUSTOMER_ROUTE = '/customers'
export const CHECKIN_SCREEN_ROUTE = '/checkin-screen'

export const MARKETING_ROUTE = '/marketing'
export const MARKETING_CREATE_ROUTE = MARKETING_ROUTE + '/create'
export const MARKETING_UPDATE_ROUTE = MARKETING_ROUTE + '/update'